import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useViewport } from '@chilecompra/react-kit'
import { Button, Skeleton, Typography } from '@chilecompra/react-kit/components'

import SummaryBid from '../../components/Custom/SummaryBid'
import AttachedFilesBlue from '../../components/Custom/AttachedFilesBlue'

import { onCloseQuoteBidSeeDetailDialog } from './QuoteBidSeeDetailDialog.actions'
import { onGetDownloadFileThunk } from '../QuoteBidSeller/QuoteBidSeller.actions'

import { Dialog, Grid } from './QuoteBidSeeDetailDialog.styles'

import { topPage } from '../../modules/utils/topPage'
import { inIframe } from '../../modules/utils/inIframe'

/**
 * The QuoteBidSeeDetailDialog's container.
 */
const QuoteBidSeeDetailDialog = () => {
  const { open } = useSelector(state => state.quoteBidSeeDetailDialog)
  const {
    quoteBidDetail: {
      amount,
      attachedFiles,
      businessName,
      detail,
      dispatchValue,
      effectiveDate,
      nethworth,
      products,
      sendDate,
      taxation,
      taxationValue
    },
    loading
  } = useSelector(state => state.quoteBid)

  const {
    basicInfo: { currency }
  } = useSelector(state => state.quoteBasicInformation)

  const dispatch = useDispatch()
  const isInIframe = useMemo(() => inIframe(), [])

  const {
    size: { isDownToTiny }
  } = useViewport()

  const handleCloseDialog = () => dispatch(onCloseQuoteBidSeeDetailDialog())
  const handleDownloadFile = ({ id, name }) => dispatch(onGetDownloadFileThunk({ id, name }))

  useEffect(() => topPage(isInIframe, open), [open])

  return (
    <Dialog open={open} maxWidth="90%" onClose={handleCloseDialog} verticalAlign="top">
      <Grid container padding="48px 24px">
        <SummaryBid
          amount={amount}
          businessName={businessName}
          detail={detail}
          dispatchValue={dispatchValue}
          effectiveDate={effectiveDate}
          loading={loading}
          netWorth={nethworth}
          products={products}
          sendDate={sendDate}
          taxation={taxation}
          taxationValue={taxationValue}
          typeCurrency={currency}
        />
        <Grid container margin="22px 0 0">
          <Grid container item md={6} xs={12}>
            <Grid item xs={12} sm={4}>
              <Typography color="black1" fontSize="14px" fontWeight="bold" lineHeight="18px" variant="body2">
                Adjuntos de la cotización
              </Typography>
            </Grid>
            <Grid item xs={12} sm>
              {!loading && attachedFiles && attachedFiles.length > 0 ? (
                attachedFiles.map(files => (
                  <AttachedFilesBlue
                    id={files.id}
                    key={files.id}
                    name={files.name}
                    onDownloadFile={handleDownloadFile}
                  />
                ))
              ) : (
                <Typography color="black3" fontSize="14px" lineHeight="18px" variant="body2">
                  {loading ? <Skeleton /> : 'No existen documentos adjuntos'}
                </Typography>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid container justifyContent="center">
          <Button
            margin="48px 0 64px"
            onClick={handleCloseDialog}
            variant="outlined"
            width={isDownToTiny ? '100%' : undefined}
          >
            Cerrar
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  )
}

export default QuoteBidSeeDetailDialog
